/** Okresy sum finansowych — parity z MPA expenses.js (client-side). */

export type FinancePeriod = "month" | "quarter" | "year";

export function periodRange(period: FinancePeriod, today = new Date()) {
  const y = today.getFullYear();
  const m = today.getMonth();
  const d = today.getDate();
  if (period === "quarter") {
    const qStart = Math.floor(m / 3) * 3;
    return {
      start: new Date(y, qStart, 1),
      end: new Date(y, m, d, 23, 59, 59, 999),
    };
  }
  if (period === "year") {
    return {
      start: new Date(y, 0, 1),
      end: new Date(y, m, d, 23, 59, 59, 999),
    };
  }
  return {
    start: new Date(y, m, 1),
    end: new Date(y, m, d, 23, 59, 59, 999),
  };
}

export function parseIsoDate(iso: string): Date {
  const parts = iso.split("-");
  return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]), 12, 0, 0);
}

export function inPeriod(isoDate: string, period: FinancePeriod, today = new Date()): boolean {
  const range = periodRange(period, today);
  const d = parseIsoDate(isoDate);
  return d >= range.start && d <= range.end;
}

export function toAmount(value: string | number | null | undefined): number {
  const num = Number(value ?? 0);
  return Number.isFinite(num) ? num : 0;
}
